'use client';

import a__default, { useLayoutEffect } from "react";
import { Text } from "../../atoms/Text/Text.js";
import { useLiveAnnouncement } from "../../utils/hooks/useLiveAnnouncement.js";
import { wrapIfTextCompatible } from "../../utils/props/wrapIfTextCompatible.js";
import { textWrapper } from "./InlineNotification.css.js";
function Contents({
  liveId,
  ...props
}) {
  const { title, description, label, a11yMessage, a11yImportance } = props;
  const descriptionRef = a__default.useRef(null);
  const announce = useLiveAnnouncement();
  useLayoutEffect(() => {
    var _a;
    if (a11yImportance === "none") return;
    const descriptionText = ((_a = descriptionRef.current) == null ? void 0 : _a.innerText) ?? "";
    const contents = a11yMessage || `${title}. ${descriptionText}`;
    announce(`${label}. ${contents}`, { id: liveId, a11yImportance });
  }, []);
  return /* @__PURE__ */ a__default.createElement("div", { className: textWrapper }, a11yMessage && /* @__PURE__ */ a__default.createElement(Text, { visuallyHidden: true }, a11yMessage), /* @__PURE__ */ a__default.createElement(
    Text,
    {
      "aria-hidden": a11yMessage ? "true" : void 0,
      color: "onLight.text.primary",
      variant: "label.md"
    },
    title
  ), description && wrapIfTextCompatible(description, (c) => /* @__PURE__ */ a__default.createElement(
    Text,
    {
      "aria-hidden": a11yMessage ? "true" : void 0,
      color: "onLight.text.primary",
      ref: descriptionRef,
      variant: "body.base"
    },
    c
  )));
}
export {
  Contents
};
